export const MESSAGE_VARIABLES = [
  { id: 'price', label: 'Amount' },
  { id: 'amountDue', label: 'Payment amount due' },
  { id: 'amountPaid', label: 'Payment amount paid' },
  { id: 'currentPeriodEnd', label: 'Next payment date' },
  { id: 'planIterations', label: 'No. of payments' },
  { id: 'createdAt', label: 'Created date' },
  { id: 'status', label: 'Status' },
  { id: 'payment_method', label: 'Payment method' },
  { id: 'orderId', label: 'Order ID' },
  { id: 'product_title', label: 'Product title' },
  { id: 'order_summary', label: 'Order summary' },
  { id: 'variant_breakdown', label: 'Variant selection' },
  { id: 'license_key', label: 'License key' },
  { id: 'sku', label: 'SKU' },
  { id: 'form_title', label: 'Form title' },
  { id: 'event_name', label: 'Event name' },
  { id: 'event_date', label: 'Event date/time' },
  { id: 'event_location', label: 'Event location' },
  { id: 'event_tickets', label: 'Tickets purchased' },
  { id: 'booking_fee', label: 'Booking fee' },
  { id: 'event_meeting_link', label: 'Virtual meeting link' },
  { id: 'customer_portal_link', label: 'Customer portal link' },
  { id: 'coupon_code', label: 'Coupon code' },
  { id: 'coupon_discount', label: 'Coupon discount' },
] as const;

export const MESSAGE_CONDITION_OPERATORS = [
  'equals',
  'not_equals',
  'contains',
  'not_contains',
  'starts_with',
  'ends_with',
  'greater_than',
  'less_than',
  'greater_than_or_equal',
  'less_than_or_equal',
] as const;

const STATIC_IDS = new Set<string>(MESSAGE_VARIABLES.map(variable => variable.id));
const PER_PAGE_ID = /^(?:field_[a-f0-9]{24}|variant_[a-f0-9]{24}(?:_sku)?)$/;

export function isMessageVariableId(id: string): boolean {
  return STATIC_IDS.has(id) || PER_PAGE_ID.test(id);
}

export function messageVariableLabel(id: string): string | undefined {
  return MESSAGE_VARIABLES.find(variable => variable.id === id)?.label;
}
